export default "__VITE_ASSET__9kr72CDW__"